import type { PricingConfigSummary } from '../../../services/api';
import { formatPricingConfigDateTime, pricingConfigIdSlug } from '../adminDashboardHelpers';

export function PricingConfigSelectOptionLabel({ config }: { config: PricingConfigSummary }) {
    const slug = pricingConfigIdSlug(config.id);
    const created = formatPricingConfigDateTime(config.createdAt);

    return (
        <span className="flex min-w-0 flex-1 items-baseline gap-x-1.5 gap-y-0">
            <span className="font-medium text-neutral-950 dark:text-neutral-50">{config.name}</span>
            <span className="shrink-0 font-medium tabular-nums text-neutral-950 dark:text-neutral-50">
                v{config.version}
            </span>
            <span className="min-w-0 flex-1 truncate font-normal text-neutral-500 dark:text-neutral-400">
                {slug} · {created}
            </span>
        </span>
    );
}
